module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("bRiJi"))).then(() => parcelRequire('3v6U2'));